// import lipstick prototype object
import { BlushProduct } from '@facecake/fmt-react-tryon/';

// load array of glasses products
const blushes = [
  { 
    brandName: 'Charlotte Tilbury',
    productName: 'BEACH STICK - Las Salinas',
    price: '$45.00',
    productPdpUrl:'https://click.linksynergy.com/deeplink?id=6V70MFsWQOU&mid=39990&murl=https%3A%2F%2Fwww.charlottetilbury.com%2Fus%2Fbeach-stick-las-salinas.html%3FistCompanyId%3Ddf2906b5-23af-4f14-b5ed-2585966c6cfa%26istItemId%3Dxilrqawlwi%26istBid%3Dtztx%26gclid%3DEAIaIQobChMImrGpnIni3wIVk8JkCh01-woYEAQYASABEgKnAvD_BwE%26gclsrc%3Daw.ds',
    productThumb: {
      unselected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_3.png',
      selected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_3_over.png',
    },
    blushProduct: new BlushProduct({
      productId: 3,
      colorHex: '0xFC6471',
      blushShape: '',
    }),
  }, { 
    brandName: 'bareMinerals',
    productName: 'READY BLUSH - The Confession',
    price: '$20.00',
    productPdpUrl: 'https://click.linksynergy.com/deeplink?id=6V70MFsWQOU&mid=42594&murl=https%3A%2F%2Fwww.bareminerals.com%2Fready-pressed-powder-blush%2FUS73462.html',
    productThumb: {
      unselected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_2.png',
      selected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_2_over.png',
     },
    blushProduct: new BlushProduct({
      productId: 2,
      colorHex: '0xFE81BE',
      blushShape: '',
    }),
  }, { 
    brandName: 'MAKE UP FOR EVER',
    productName: 'HD Blush - Radiant Finish',
    price: '$26.00',
    productPdpUrl: 'https://click.linksynergy.com/deeplink?id=IZ2bxbwEz0M&mid=2417&murl=https%3A%2F%2Fwww.sephora.com%2Fproduct%2Fhd-blush-P384744%3FskuId%3D1574649%26om_mmc%3Dppc-GG_1165716884_53825912300_pla-423552009092_1574649_257731948202_9031176_c%26country_switch%3Dus%26lang%3Den%26ds_rl%3D1261471%26gclid%3DEAIaIQobChMI4umuvIXi3wIVlLfsCh3nDgNHEAQYAiABEgINmPD_BwE%26gclsrc%3Daw.ds',
    productThumb: {
      unselected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_1.png',
      selected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_1_over.png',
    },
    blushProduct: new BlushProduct({
      productId: 1,
      colorHex: '0xFF7660',
      blushShape: '',
    }),
  },  { 
    brandName: 'Hourglass Ambient',
    productName: 'Lighting  Blush - Dim Infusion',
    price: '$38.00',
    productPdpUrl:'https://click.linksynergy.com/deeplink?id=IZ2bxbwEz0M&mid=2417&murl=https%3A%2F%2Fwww.sephora.com%2Fproduct%2Fambient-lighting-blush-collection-P384963%3FskuId%3D1581297',
    productThumb: {
      unselected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_4.png',
      selected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_4_over.png',
    },
    blushProduct: new BlushProduct({
      productId: 4,
      colorHex: '0xED8E96',
      blushShape: '',
    }),
  }, { 
    brandName: 'Hourglass Ambient',
    productName: 'Lighting  Blush - Dim Infusion',
    price: '$38.00',
    productPdpUrl:'https://click.linksynergy.com/deeplink?id=IZ2bxbwEz0M&mid=2417&murl=https%3A%2F%2Fwww.sephora.com%2Fproduct%2Fambient-lighting-blush-collection-P384963%3FskuId%3D1581297',
    productThumb: {
      unselected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_5.png',
      selected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_5_over.png',
    },
    blushProduct: new BlushProduct({
      productId: 5,
      colorHex: '0xDB707E',
      blushShape: '',
    }),
  }, { 
    brandName: 'Hourglass Ambient',
    productName: 'Lighting  Blush - Dim Infusion',
    price: '$38.00',
    productPdpUrl:'https://click.linksynergy.com/deeplink?id=IZ2bxbwEz0M&mid=2417&murl=https%3A%2F%2Fwww.sephora.com%2Fproduct%2Fambient-lighting-blush-collection-P384963%3FskuId%3D1581297',
    productThumb: {
      unselected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_6.png',
      selected: 'https://demos.facecake.com/blushing/images/products/blush/blush_swatch_6_over.png',
    },
    blushProduct: new BlushProduct({
      productId: 6,
      colorHex: '0xC87672',
      blushShape: '',
    }),
  }

];

export default blushes;